import script from "./VerifyRecordList.vue?vue&type=script&setup=true&lang=js"
export * from "./VerifyRecordList.vue?vue&type=script&setup=true&lang=js"

import "./VerifyRecordList.vue?vue&type=style&index=0&id=46b478d2&scoped=true&lang=css"

import exportComponent from "E:\\Java\\GongJu\\idea\\job\\job_slcj\\job_vue_boot\\job_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46b478d2"]])

export default __exports__